import React from 'react';
import './style.scss';
import { IoMdCheckmark } from 'react-icons/io';

const DEFAULT_STEPS = [
  { id: 1, label: 'Event Details' },
  { id: 2, label: 'Product Details' },
  { id: 3, label: 'Preview & Publish' },
];

export default function StepBar({
  steps = DEFAULT_STEPS,
  currentStep = 1,
  onStepClick,
}) {
  return (
    <div className="steps-bar">
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isDone = stepNumber < currentStep;
        const isActive = stepNumber === currentStep;
        const isLast = index === steps.length - 1;

        const label = typeof step === 'string' ? step : step.label;
        const statusClass = isDone ? 'done' : isActive ? 'active' : 'todo';

        return (
          <React.Fragment key={step.id || index}>
            <div
              className="step"
              onClick={() => onStepClick && onStepClick(stepNumber, step)}
            >
              <div className={`step-circle ${statusClass}`}>
                {isDone ? <IoMdCheckmark size={12} /> : stepNumber}
              </div>
              <div className={`step-lbl ${statusClass}`}>{label}</div>
            </div>

            {!isLast && (
              <div className={`step-line ${isDone ? 'done' : ''}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
